/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './new-received-piece.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as i3 from '@angular/material';
import * as i4 from '../../../../../app/shared/pipes/translate.pipe';
import * as i5 from '@angular/forms';
import * as i6 from '@angular/flex-layout/flexbox/api/flex';
import * as i7 from '@angular/flex-layout/media-query/media-monitor';
import * as i8 from '@angular/flex-layout/flexbox/api/layout';
import * as i9 from '@angular/flex-layout/flexbox/api/layout-wrap';
import * as i10 from '../../../../../app/shared/dialogs/new-received-piece/new-received-piece.component';
import * as i11 from '@angular/platform-browser';
import * as i12 from '@angular/common';
import * as i13 from '@angular/flex-layout/flexbox/api/layout-gap';
import * as i14 from '@angular/flex-layout/flexbox/api/flex-align';
import * as i15 from '@angular/flex-layout/flexbox/api/class';
import * as i16 from '../../../../../app/agatextscreens/purchasing/products/product.service';
import * as i17 from '@angular/http';
import * as i18 from '../../../../../app/app.constants';
import * as i19 from '../../../../../app/shared/services/authentication.service';
import * as i20 from '../../../../../app/shared/services/collection.service';
import * as i21 from '@covalent/core/dialogs/services/dialog.service';
const styles_NewReceivedPieceComponent:any[] = [i0.styles];
export const RenderType_NewReceivedPieceComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_NewReceivedPieceComponent,data:{}});
function View_NewReceivedPieceComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-option',[['role',
      'option']],[[1,'tabindex',0],[2,'mat-selected',(null as any)],[2,'mat-option-multiple',
      (null as any)],[2,'mat-active',(null as any)],[8,'id',0],[1,'aria-selected',
      0],[1,'aria-disabled',0],[2,'mat-option-disabled',(null as any)],[2,'mat-option',
      (null as any)]],[[(null as any),'click'],[(null as any),'keydown']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,2)._selectViaInteraction()) !== false);
      ad = (pd_0 && ad);
    }
    if (('keydown' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,2)._handleKeydown($event)) !== false);
      ad = (pd_1 && ad);
    }
    if (('click' === en)) {
      const pd_2:any = ((<any>_co.setSelected(_v.context.$implicit)) !== false);
      ad = (pd_2 && ad);
    }
    return ad;
  },i2.View_MdOption_0,i2.RenderType_MdOption)),i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,
      [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49152,[[13,4]],0,i3.MdOption,[i1.ElementRef,[2,i3.MATERIAL_COMPATIBILITY_MODE]],
          {value:[0,'value']},(null as any)),(_l()(),i1.ɵted(0,['\n        ','\n      ']))],
      (_ck,_v) => {
        const currVal_9:any = ((((((_v.context.$implicit == null)? (null as any): _v.context.$implicit.collection_name) + ' - ') + ((_v.context.$implicit == null)? (null as any): _v.context.$implicit.design_name)) + '/') + ((_v.context.$implicit == null)? (null as any): _v.context.$implicit.name));
        _ck(_v,2,0,currVal_9);
      },(_ck,_v) => {
        const currVal_0:any = i1.ɵnov(_v,2)._getTabIndex();
        const currVal_1:any = i1.ɵnov(_v,2).selected;
        const currVal_2:any = i1.ɵnov(_v,2).multiple;
        const currVal_3:any = i1.ɵnov(_v,2).active;
        const currVal_4:any = i1.ɵnov(_v,2).id;
        const currVal_5:any = i1.ɵnov(_v,2).selected.toString();
        const currVal_6:any = i1.ɵnov(_v,2).disabled.toString();
        const currVal_7:any = i1.ɵnov(_v,2).disabled;
        const currVal_8:any = true;
        _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
            currVal_7,currVal_8);
        const currVal_10:any = ((((((_v.context.$implicit == null)? (null as any): _v.context.$implicit.collection_name) + ' - ') + ((_v.context.$implicit == null)? (null as any): _v.context.$implicit.design_name)) + '/') + ((_v.context.$implicit == null)? (null as any): _v.context.$implicit.name));
        _ck(_v,3,0,currVal_10);
      });
}
export function View_NewReceivedPieceComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵpid(0,i4.TranslatePipe,([] as any[])),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),141,'div',[['flex',''],['layout','column'],['layout-margin',''],
          ['layout-wrap',''],['style','min-width: 500px;']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n  '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),4,'div',[['flex','']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'h4',([] as any[]),
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['New Piece'])),(_l()(),i1.ɵted((null as any),
          ['\n  '])),(_l()(),i1.ɵted((null as any),['\n  '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),18,'md-input-container',[['fxFlex','40%']],[[1,'align',0],
              [2,'mat-input-container',(null as any)],[2,'mat-input-invalid',(null as any)],
              [2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],[2,
                  'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,10)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_MdInputContainer_0,i2.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i3.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i5.NgForm],[2,i5.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,1,{_mdInputChild:0}),i1.ɵqud(335544320,2,{_placeholderChild:0}),
      i1.ɵqud(603979776,3,{_errorChildren:1}),i1.ɵqud(603979776,4,{_hintChildren:1}),
      i1.ɵqud(603979776,5,{_prefixChildren:1}),i1.ɵqud(603979776,6,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i6.FlexDirective,[i7.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i8.LayoutDirective],[3,i9.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n    '])),(_l()(),i1.ɵeld(0,
          (null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)],[2,'mat-input-element',(null as any)],
              [8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',0],[1,
                  'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
              'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
              'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i10.NewReceivedPieceComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,20)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,20).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,20)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,20)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,25)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,25)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,25)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.piece.piece_no = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i5.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i5.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i5.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i5.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i5.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i5.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i5.NgControl,
          (null as any),[i5.NgModel]),i1.ɵdid(16384,(null as any),0,i5.NgControlStatus,
          [i5.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[1,4]],0,i3.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i5.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n  '])),(_l()(),i1.ɵted((null as any),
          ['\n\n\n\n  '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),26,'md-input-container',
          ([] as any[]),[[1,'align',0],[2,'mat-input-container',(null as any)],[2,
              'mat-input-invalid',(null as any)],[2,'mat-focused',(null as any)],[2,
              'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
              (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,30)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_MdInputContainer_0,i2.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i3.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i5.NgForm],[2,i5.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,7,{_mdInputChild:0}),i1.ɵqud(335544320,8,{_placeholderChild:0}),
      i1.ɵqud(603979776,9,{_errorChildren:1}),i1.ɵqud(603979776,10,{_hintChildren:1}),
      i1.ɵqud(603979776,11,{_prefixChildren:1}),i1.ɵqud(603979776,12,{_suffixChildren:1}),
      (_l()(),i1.ɵted(1,['\n    '])),(_l()(),i1.ɵeld(16777216,(null as any),1,7,'input',
          [['aria-autocomplete','list'],['aria-multiline','false'],['autocomplete',
              'off'],['flex',''],['mdInput',''],['placeholder','Collection - Design/Color'],
              ['role','combobox']],[[1,'aria-activedescendant',0],[1,'aria-expanded',
              0],[1,'aria-owns',0],[2,'ng-untouched',(null as any)],[2,'ng-touched',
              (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
              [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
                  (null as any)],[2,'mat-input-element',(null as any)],[8,'id',0],
              [8,'placeholder',0],[8,'disabled',0],[8,'required',0],[1,'aria-describedby',
                  0]],[[(null as any),'ngModelChange'],[(null as any),'input'],[(null as any),
              'blur'],[(null as any),'compositionstart'],[(null as any),'compositionend'],
              [(null as any),'focus'],[(null as any),'keydown']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i10.NewReceivedPieceComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,39)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,39).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,39)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,39)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('focus' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,40).openPanel()) !== false);
              ad = (pd_4 && ad);
            }
            if (('input' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,40)._handleInput($event)) !== false);
              ad = (pd_5 && ad);
            }
            if (('blur' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,40)._onTouched()) !== false);
              ad = (pd_6 && ad);
            }
            if (('keydown' === en)) {
              const pd_7:any = ((<any>i1.ɵnov(_v,40)._handleKeydown($event)) !== false);
              ad = (pd_7 && ad);
            }
            if (('blur' === en)) {
              const pd_8:any = ((<any>i1.ɵnov(_v,45)._onBlur()) !== false);
              ad = (pd_8 && ad);
            }
            if (('focus' === en)) {
              const pd_9:any = ((<any>i1.ɵnov(_v,45)._onFocus()) !== false);
              ad = (pd_9 && ad);
            }
            if (('input' === en)) {
              const pd_10:any = ((<any>i1.ɵnov(_v,45)._onInput()) !== false);
              ad = (pd_10 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_11:any = ((<any>(_co.prod = $event)) !== false);
              ad = (pd_11 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_12:any = ((<any>_co.filterProducts(_co.prod)) !== false);
              ad = (pd_12 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i5.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i5.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵdid(147456,(null as any),0,i3.MdAutocompleteTrigger,[i1.ElementRef,
          i3.Overlay,i1.ViewContainerRef,i1.ChangeDetectorRef,i3.ScrollDispatcher,
          [2,i3.Dir],i1.NgZone,[2,i3.MdInputContainer],[2,i11.DOCUMENT]],{autocomplete:[0,
          'autocomplete']},(null as any)),i1.ɵprd(1024,(null as any),i5.NG_VALUE_ACCESSOR,
          (p0_0:any,p1_0:any) => {
            return [p0_0,p1_0];
          },[i5.DefaultValueAccessor,i3.MdAutocompleteTrigger]),i1.ɵdid(671744,(null as any),
          0,i5.NgModel,[[8,(null as any)],[8,(null as any)],[8,(null as any)],[2,i5.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i5.NgControl,(null as any),[i5.NgModel]),i1.ɵdid(16384,(null as any),0,i5.NgControlStatus,
          [i5.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[7,4]],0,i3.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i5.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),(_l()(),i1.ɵted(1,['\n    '])),(_l()(),i1.ɵeld(0,(null as any),
          1,7,'md-autocomplete',([] as any[]),[[2,'mat-autocomplete',(null as any)]],
          (null as any),(null as any),i2.View_MdAutocomplete_0,i2.RenderType_MdAutocomplete)),
      i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(1097728,[['autoColor',
          4]],1,i3.MdAutocomplete,[i1.ChangeDetectorRef],(null as any),(null as any)),
      i1.ɵqud(603979776,13,{options:1}),(_l()(),i1.ɵted(0,['\n      '])),(_l()(),i1.ɵand(16777216,
          (null as any),0,1,(null as any),View_NewReceivedPieceComponent_1)),i1.ɵdid(802816,
          (null as any),0,i12.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,i1.IterableDiffers],
          {ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(0,['\n    '])),(_l()(),
          i1.ɵted(1,['\n  '])),(_l()(),i1.ɵted((null as any),['\n\n'])),(_l()(),i1.ɵted((null as any),
          ['\n\n  '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',
          [['fxFlex','40%']],[[1,'align',0],[2,'mat-input-container',(null as any)],
              [2,'mat-input-invalid',(null as any)],[2,'mat-focused',(null as any)],
              [2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
                  (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,59)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_MdInputContainer_0,i2.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i3.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i5.NgForm],[2,i5.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,14,{_mdInputChild:0}),i1.ɵqud(335544320,15,{_placeholderChild:0}),
      i1.ɵqud(603979776,16,{_errorChildren:1}),i1.ɵqud(603979776,17,{_hintChildren:1}),
      i1.ɵqud(603979776,18,{_prefixChildren:1}),i1.ɵqud(603979776,19,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i6.FlexDirective,[i7.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i8.LayoutDirective],[3,i9.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n    '])),(_l()(),i1.ɵeld(0,
          (null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)],[2,'mat-input-element',(null as any)],
              [8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',0],[1,
                  'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
              'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
              'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i10.NewReceivedPieceComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,69)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,69).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,69)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,69)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,74)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,74)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,74)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.piece.lot_no = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i5.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i5.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i5.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i5.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i5.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i5.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i5.NgControl,
          (null as any),[i5.NgModel]),i1.ɵdid(16384,(null as any),0,i5.NgControlStatus,
          [i5.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[14,4]],0,i3.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i5.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n  '])),(_l()(),i1.ɵted((null as any),
          ['\n  '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',
          [['fxFlex','40%']],[[1,'align',0],[2,'mat-input-container',(null as any)],
              [2,'mat-input-invalid',(null as any)],[2,'mat-focused',(null as any)],
              [2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
                  (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,79)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_MdInputContainer_0,i2.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i3.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i5.NgForm],[2,i5.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,20,{_mdInputChild:0}),i1.ɵqud(335544320,21,{_placeholderChild:0}),
      i1.ɵqud(603979776,22,{_errorChildren:1}),i1.ɵqud(603979776,23,{_hintChildren:1}),
      i1.ɵqud(603979776,24,{_prefixChildren:1}),i1.ɵqud(603979776,25,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i6.FlexDirective,[i7.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i8.LayoutDirective],[3,i9.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n    '])),(_l()(),i1.ɵeld(0,
          (null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)],[2,'mat-input-element',(null as any)],
              [8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',0],[1,
                  'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
              'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
              'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i10.NewReceivedPieceComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,89)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,89).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,89)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,89)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,94)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,94)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,94)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.piece.length = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i5.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i5.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i5.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i5.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i5.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i5.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i5.NgControl,
          (null as any),[i5.NgModel]),i1.ɵdid(16384,(null as any),0,i5.NgControlStatus,
          [i5.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[20,4]],0,i3.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i5.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n  '])),(_l()(),i1.ɵted((null as any),
          ['\n  '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',
          [['fxFlex','40%']],[[1,'align',0],[2,'mat-input-container',(null as any)],
              [2,'mat-input-invalid',(null as any)],[2,'mat-focused',(null as any)],
              [2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
                  (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,99)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_MdInputContainer_0,i2.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i3.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i5.NgForm],[2,i5.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,26,{_mdInputChild:0}),i1.ɵqud(335544320,27,{_placeholderChild:0}),
      i1.ɵqud(603979776,28,{_errorChildren:1}),i1.ɵqud(603979776,29,{_hintChildren:1}),
      i1.ɵqud(603979776,30,{_prefixChildren:1}),i1.ɵqud(603979776,31,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i6.FlexDirective,[i7.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i8.LayoutDirective],[3,i9.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n    '])),(_l()(),i1.ɵeld(0,
          (null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)],[2,'mat-input-element',(null as any)],
              [8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',0],[1,
                  'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
              'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
              'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i10.NewReceivedPieceComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,109)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,109).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,109)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,109)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,114)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,114)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,114)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.piece.weight = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i5.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i5.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i5.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i5.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i5.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i5.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i5.NgControl,
          (null as any),[i5.NgModel]),i1.ɵdid(16384,(null as any),0,i5.NgControlStatus,
          [i5.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[26,4]],0,i3.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i5.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n  '])),(_l()(),i1.ɵted((null as any),
          ['\n\n  '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),23,'div',[['class',
          'table-control-buttons'],['fxFlex',''],['fxFlexAlign','start'],['fxFlexAlign.lt-md',
          'center'],['fxLayoutGap','12px']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),i1.ɵdid(1720320,(null as any),0,i13.LayoutGapDirective,
          [i7.MediaMonitor,i1.ElementRef,i1.Renderer2,[8,(null as any)]],{gap:[0,'gap']},
          (null as any)),i1.ɵdid(737280,(null as any),0,i6.FlexDirective,[i7.MediaMonitor,
          i1.ElementRef,i1.Renderer2,[3,i8.LayoutDirective],[3,i9.LayoutWrapDirective]],
          {flex:[0,'flex']},(null as any)),i1.ɵdid(737280,(null as any),0,i14.FlexAlignDirective,
          [i7.MediaMonitor,i1.ElementRef,i1.Renderer2],{align:[0,'align'],alignLtMd:[1,
              'alignLtMd']},(null as any)),i1.ɵdid(933888,(null as any),0,i15.ClassDirective,
          [i7.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
              i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),7,'button',[['class',
          'bg-blue color-white mat-button mat-raised-button'],['color','primary'],
          ['md-button',''],['md-raised-button','']],[[8,'disabled',0]],[[(null as any),
          'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i10.NewReceivedPieceComponent = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.confirm()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i2.View_MdButton_0,i2.RenderType_MdButton)),i1.ɵdid(16384,(null as any),0,
          i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
          (null as any)),i1.ɵdid(180224,(null as any),0,i3.MdButton,[i1.ElementRef,
          i1.Renderer2,i3.Platform,i3.FocusOriginMonitor],{color:[0,'color']},(null as any)),
      i1.ɵdid(16384,(null as any),0,i3.MdButtonCssMatStyler,([] as any[]),(null as any),
          (null as any)),i1.ɵdid(16384,(null as any),0,i3.MdRaisedButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,(null as any),
          0,i15.ClassDirective,[i7.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2),(_l()(),i1.ɵted((null as any),
          ['\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),7,'button',[['class',
          'bg-red color-white mat-button mat-raised-button'],['color','warn'],['md-button',
          ''],['md-raised-button','']],[[8,'disabled',0]],[[(null as any),'click']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:i10.NewReceivedPieceComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co._ref.close()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_MdButton_0,i2.RenderType_MdButton)),i1.ɵdid(16384,(null as any),
          0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(180224,(null as any),0,i3.MdButton,
          [i1.ElementRef,i1.Renderer2,i3.Platform,i3.FocusOriginMonitor],{color:[0,
              'color']},(null as any)),i1.ɵdid(16384,(null as any),0,i3.MdButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),i1.ɵdid(16384,(null as any),0,
          i3.MdRaisedButtonCssMatStyler,([] as any[]),(null as any),(null as any)),
      i1.ɵdid(933888,(null as any),0,i15.ClassDirective,[i7.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2),(_l()(),
          i1.ɵted((null as any),['\n  '])),(_l()(),i1.ɵted((null as any),['\n']))],
      (_ck,_v) => {
        var _co:i10.NewReceivedPieceComponent = _v.component;
        const currVal_11:any = '40%';
        _ck(_v,17,0,currVal_11);
        const currVal_25:any = _co.piece.piece_no;
        _ck(_v,22,0,currVal_25);
        const currVal_26:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,25,0,_ck(_v,26,
            0,i1.ɵnov(_v,0),'piece_number',_co._authService.getLanguage())),'');
        _ck(_v,25,0,currVal_26);
        const currVal_54:any = i1.ɵnov(_v,49);
        _ck(_v,40,0,currVal_54);
        const currVal_55:any = _co.prod;
        _ck(_v,42,0,currVal_55);
        const currVal_56:any = 'Collection - Design/Color';
        _ck(_v,45,0,currVal_56);
        const currVal_58:any = _co.matchingProducts;
        _ck(_v,53,0,currVal_58);
        const currVal_70:any = '40%';
        _ck(_v,66,0,currVal_70);
        const currVal_84:any = _co.piece.lot_no;
        _ck(_v,71,0,currVal_84);
        const currVal_85:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,74,0,_ck(_v,75,
            0,i1.ɵnov(_v,0),'lot_no',_co._authService.getLanguage())),'');
        _ck(_v,74,0,currVal_85);
        const currVal_97:any = '40%';
        _ck(_v,86,0,currVal_97);
        const currVal_111:any = _co.piece.length;
        _ck(_v,91,0,currVal_111);
        const currVal_112:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,94,0,_ck(_v,
            95,0,i1.ɵnov(_v,0),'length',_co._authService.getLanguage())),'');
        _ck(_v,94,0,currVal_112);
        const currVal_124:any = '40%';
        _ck(_v,106,0,currVal_124);
        const currVal_138:any = _co.piece.weight;
        _ck(_v,111,0,currVal_138);
        const currVal_139:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,114,0,_ck(_v,
            115,0,i1.ɵnov(_v,0),'weight',_co._authService.getLanguage())),'');
        _ck(_v,114,0,currVal_139);
        const currVal_140:any = '12px';
        _ck(_v,119,0,currVal_140);
        const currVal_141:any = '';
        _ck(_v,120,0,currVal_141);
        const currVal_142:any = 'start';
        const currVal_143:any = 'center';
        _ck(_v,121,0,currVal_142,currVal_143);
        const currVal_144:any = 'table-control-buttons';
        _ck(_v,122,0,currVal_144);
        const currVal_146:any = 'primary';
        _ck(_v,126,0,currVal_146);
        const currVal_147:any = 'bg-blue color-white';
        _ck(_v,129,0,currVal_147);
        const currVal_150:any = 'warn';
        _ck(_v,135,0,currVal_150);
        const currVal_151:any = 'bg-red color-white';
        _ck(_v,138,0,currVal_151);
      },(_ck,_v) => {
        var _co:i10.NewReceivedPieceComponent = _v.component;
        const currVal_0:any = (null as any);
        const currVal_1:any = true;
        const currVal_2:any = i1.ɵnov(_v,10)._isErrorState();
        const currVal_3:any = i1.ɵnov(_v,10)._mdInputChild.focused;
        const currVal_4:any = i1.ɵnov(_v,10)._shouldForward('untouched');
        const currVal_5:any = i1.ɵnov(_v,10)._shouldForward('touched');
        const currVal_6:any = i1.ɵnov(_v,10)._shouldForward('pristine');
        const currVal_7:any = i1.ɵnov(_v,10)._shouldForward('dirty');
        const currVal_8:any = i1.ɵnov(_v,10)._shouldForward('valid');
        const currVal_9:any = i1.ɵnov(_v,10)._shouldForward('invalid');
        const currVal_10:any = i1.ɵnov(_v,10)._shouldForward('pending');
        _ck(_v,9,1,[currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
            currVal_7,currVal_8,currVal_9,currVal_10]);
        const currVal_12:any = i1.ɵnov(_v,24).ngClassUntouched;
        const currVal_13:any = i1.ɵnov(_v,24).ngClassTouched;
        const currVal_14:any = i1.ɵnov(_v,24).ngClassPristine;
        const currVal_15:any = i1.ɵnov(_v,24).ngClassDirty;
        const currVal_16:any = i1.ɵnov(_v,24).ngClassValid;
        const currVal_17:any = i1.ɵnov(_v,24).ngClassInvalid;
        const currVal_18:any = i1.ɵnov(_v,24).ngClassPending;
        const currVal_19:any = true;
        const currVal_20:any = i1.ɵnov(_v,25).id;
        const currVal_21:any = i1.ɵnov(_v,25).placeholder;
        const currVal_22:any = i1.ɵnov(_v,25).disabled;
        const currVal_23:any = i1.ɵnov(_v,25).required;
        const currVal_24:any = (i1.ɵnov(_v,25).ariaDescribedby || (null as any));
        _ck(_v,19,1,[currVal_12,currVal_13,currVal_14,currVal_15,currVal_16,currVal_17,
            currVal_18,currVal_19,currVal_20,currVal_21,currVal_22,currVal_23,currVal_24]);
        const currVal_27:any = (null as any);
        const currVal_28:any = true;
        const currVal_29:any = i1.ɵnov(_v,30)._isErrorState();
        const currVal_30:any = i1.ɵnov(_v,30)._mdInputChild.focused;
        const currVal_31:any = i1.ɵnov(_v,30)._shouldForward('untouched');
        const currVal_32:any = i1.ɵnov(_v,30)._shouldForward('touched');
        const currVal_33:any = i1.ɵnov(_v,30)._shouldForward('pristine');
        const currVal_34:any = i1.ɵnov(_v,30)._shouldForward('dirty');
        const currVal_35:any = i1.ɵnov(_v,30)._shouldForward('valid');
        const currVal_36:any = i1.ɵnov(_v,30)._shouldForward('invalid');
        const currVal_37:any = i1.ɵnov(_v,30)._shouldForward('pending');
        _ck(_v,29,1,[currVal_27,currVal_28,currVal_29,currVal_30,currVal_31,currVal_32,
            currVal_33,currVal_34,currVal_35,currVal_36,currVal_37]);
        const currVal_38:any = ((i1.ɵnov(_v,40).activeOption == null)? (null as any): i1.ɵnov(_v,
            40).activeOption.id);
        const currVal_39:any = i1.ɵnov(_v,40).panelOpen.toString();
        const currVal_40:any = ((i1.ɵnov(_v,40).autocomplete == null)? (null as any): i1.ɵnov(_v,
            40).autocomplete.id);
        const currVal_41:any = i1.ɵnov(_v,44).ngClassUntouched;
        const currVal_42:any = i1.ɵnov(_v,44).ngClassTouched;
        const currVal_43:any = i1.ɵnov(_v,44).ngClassPristine;
        const currVal_44:any = i1.ɵnov(_v,44).ngClassDirty;
        const currVal_45:any = i1.ɵnov(_v,44).ngClassValid;
        const currVal_46:any = i1.ɵnov(_v,44).ngClassInvalid;
        const currVal_47:any = i1.ɵnov(_v,44).ngClassPending;
        const currVal_48:any = true;
        const currVal_49:any = i1.ɵnov(_v,45).id;
        const currVal_50:any = i1.ɵnov(_v,45).placeholder;
        const currVal_51:any = i1.ɵnov(_v,45).disabled;
        const currVal_52:any = i1.ɵnov(_v,45).required;
        const currVal_53:any = (i1.ɵnov(_v,45).ariaDescribedby || (null as any));
        _ck(_v,38,1,[currVal_38,currVal_39,currVal_40,currVal_41,currVal_42,currVal_43,
            currVal_44,currVal_45,currVal_46,currVal_47,currVal_48,currVal_49,currVal_50,
            currVal_51,currVal_52,currVal_53]);
        const currVal_57:any = true;
        _ck(_v,47,0,currVal_57);
        const currVal_59:any = (null as any);
        const currVal_60:any = true;
        const currVal_61:any = i1.ɵnov(_v,59)._isErrorState();
        const currVal_62:any = i1.ɵnov(_v,59)._mdInputChild.focused;
        const currVal_63:any = i1.ɵnov(_v,59)._shouldForward('untouched');
        const currVal_64:any = i1.ɵnov(_v,59)._shouldForward('touched');
        const currVal_65:any = i1.ɵnov(_v,59)._shouldForward('pristine');
        const currVal_66:any = i1.ɵnov(_v,59)._shouldForward('dirty');
        const currVal_67:any = i1.ɵnov(_v,59)._shouldForward('valid');
        const currVal_68:any = i1.ɵnov(_v,59)._shouldForward('invalid');
        const currVal_69:any = i1.ɵnov(_v,59)._shouldForward('pending');
        _ck(_v,58,1,[currVal_59,currVal_60,currVal_61,currVal_62,currVal_63,currVal_64,
            currVal_65,currVal_66,currVal_67,currVal_68,currVal_69]);
        const currVal_71:any = i1.ɵnov(_v,73).ngClassUntouched;
        const currVal_72:any = i1.ɵnov(_v,73).ngClassTouched;
        const currVal_73:any = i1.ɵnov(_v,73).ngClassPristine;
        const currVal_74:any = i1.ɵnov(_v,73).ngClassDirty;
        const currVal_75:any = i1.ɵnov(_v,73).ngClassValid;
        const currVal_76:any = i1.ɵnov(_v,73).ngClassInvalid;
        const currVal_77:any = i1.ɵnov(_v,73).ngClassPending;
        const currVal_78:any = true;
        const currVal_79:any = i1.ɵnov(_v,74).id;
        const currVal_80:any = i1.ɵnov(_v,74).placeholder;
        const currVal_81:any = i1.ɵnov(_v,74).disabled;
        const currVal_82:any = i1.ɵnov(_v,74).required;
        const currVal_83:any = (i1.ɵnov(_v,74).ariaDescribedby || (null as any));
        _ck(_v,68,1,[currVal_71,currVal_72,currVal_73,currVal_74,currVal_75,currVal_76,
            currVal_77,currVal_78,currVal_79,currVal_80,currVal_81,currVal_82,currVal_83]);
        const currVal_86:any = (null as any);
        const currVal_87:any = true;
        const currVal_88:any = i1.ɵnov(_v,79)._isErrorState();
        const currVal_89:any = i1.ɵnov(_v,79)._mdInputChild.focused;
        const currVal_90:any = i1.ɵnov(_v,79)._shouldForward('untouched');
        const currVal_91:any = i1.ɵnov(_v,79)._shouldForward('touched');
        const currVal_92:any = i1.ɵnov(_v,79)._shouldForward('pristine');
        const currVal_93:any = i1.ɵnov(_v,79)._shouldForward('dirty');
        const currVal_94:any = i1.ɵnov(_v,79)._shouldForward('valid');
        const currVal_95:any = i1.ɵnov(_v,79)._shouldForward('invalid');
        const currVal_96:any = i1.ɵnov(_v,79)._shouldForward('pending');
        _ck(_v,78,1,[currVal_86,currVal_87,currVal_88,currVal_89,currVal_90,currVal_91,
            currVal_92,currVal_93,currVal_94,currVal_95,currVal_96]);
        const currVal_98:any = i1.ɵnov(_v,93).ngClassUntouched;
        const currVal_99:any = i1.ɵnov(_v,93).ngClassTouched;
        const currVal_100:any = i1.ɵnov(_v,93).ngClassPristine;
        const currVal_101:any = i1.ɵnov(_v,93).ngClassDirty;
        const currVal_102:any = i1.ɵnov(_v,93).ngClassValid;
        const currVal_103:any = i1.ɵnov(_v,93).ngClassInvalid;
        const currVal_104:any = i1.ɵnov(_v,93).ngClassPending;
        const currVal_105:any = true;
        const currVal_106:any = i1.ɵnov(_v,94).id;
        const currVal_107:any = i1.ɵnov(_v,94).placeholder;
        const currVal_108:any = i1.ɵnov(_v,94).disabled;
        const currVal_109:any = i1.ɵnov(_v,94).required;
        const currVal_110:any = (i1.ɵnov(_v,94).ariaDescribedby || (null as any));
        _ck(_v,88,1,[currVal_98,currVal_99,currVal_100,currVal_101,currVal_102,currVal_103,
            currVal_104,currVal_105,currVal_106,currVal_107,currVal_108,currVal_109,
            currVal_110]);
        const currVal_113:any = (null as any);
        const currVal_114:any = true;
        const currVal_115:any = i1.ɵnov(_v,99)._isErrorState();
        const currVal_116:any = i1.ɵnov(_v,99)._mdInputChild.focused;
        const currVal_117:any = i1.ɵnov(_v,99)._shouldForward('untouched');
        const currVal_118:any = i1.ɵnov(_v,99)._shouldForward('touched');
        const currVal_119:any = i1.ɵnov(_v,99)._shouldForward('pristine');
        const currVal_120:any = i1.ɵnov(_v,99)._shouldForward('dirty');
        const currVal_121:any = i1.ɵnov(_v,99)._shouldForward('valid');
        const currVal_122:any = i1.ɵnov(_v,99)._shouldForward('invalid');
        const currVal_123:any = i1.ɵnov(_v,99)._shouldForward('pending');
        _ck(_v,98,1,[currVal_113,currVal_114,currVal_115,currVal_116,currVal_117,currVal_118,
            currVal_119,currVal_120,currVal_121,currVal_122,currVal_123]);
        const currVal_125:any = i1.ɵnov(_v,113).ngClassUntouched;
        const currVal_126:any = i1.ɵnov(_v,113).ngClassTouched;
        const currVal_127:any = i1.ɵnov(_v,113).ngClassPristine;
        const currVal_128:any = i1.ɵnov(_v,113).ngClassDirty;
        const currVal_129:any = i1.ɵnov(_v,113).ngClassValid;
        const currVal_130:any = i1.ɵnov(_v,113).ngClassInvalid;
        const currVal_131:any = i1.ɵnov(_v,113).ngClassPending;
        const currVal_132:any = true;
        const currVal_133:any = i1.ɵnov(_v,114).id;
        const currVal_134:any = i1.ɵnov(_v,114).placeholder;
        const currVal_135:any = i1.ɵnov(_v,114).disabled;
        const currVal_136:any = i1.ɵnov(_v,114).required;
        const currVal_137:any = (i1.ɵnov(_v,114).ariaDescribedby || (null as any));
        _ck(_v,108,1,[currVal_125,currVal_126,currVal_127,currVal_128,currVal_129,
            currVal_130,currVal_131,currVal_132,currVal_133,currVal_134,currVal_135,
            currVal_136,currVal_137]);
        const currVal_145:any = (i1.ɵnov(_v,126).disabled || (null as any));
        _ck(_v,124,0,currVal_145);
        const currVal_148:any = i1.ɵunv(_v,130,0,_ck(_v,131,0,i1.ɵnov(_v,0),'add_piece',
            _co._authService.getLanguage()));
        _ck(_v,130,0,currVal_148);
        const currVal_149:any = (i1.ɵnov(_v,135).disabled || (null as any));
        _ck(_v,133,0,currVal_149);
        const currVal_152:any = i1.ɵunv(_v,139,0,_ck(_v,140,0,i1.ɵnov(_v,0),'close',
            _co._authService.getLanguage()));
        _ck(_v,139,0,currVal_152);
      });
}
export function View_NewReceivedPieceComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'app-new-received-piece',
      ([] as any[]),(null as any),(null as any),(null as any),View_NewReceivedPieceComponent_0,
      RenderType_NewReceivedPieceComponent)),i1.ɵprd(512,(null as any),i16.ProductService,
      i16.ProductService,[i17.Http,i18.Configuration,i19.AuthenticationService]),i1.ɵprd(512,
      (null as any),i20.CollectionService,i20.CollectionService,[i17.Http,i18.Configuration,
          i19.AuthenticationService]),i1.ɵdid(245760,(null as any),0,i10.NewReceivedPieceComponent,
      [i3.MdDialogRef,i16.ProductService,i20.CollectionService,i19.AuthenticationService,
          i21.TdDialogService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,3,0);
  },(null as any));
}
export const NewReceivedPieceComponentNgFactory:i1.ComponentFactory<i10.NewReceivedPieceComponent> = i1.ɵccf('app-new-received-piece',
    i10.NewReceivedPieceComponent,View_NewReceivedPieceComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/$$_gendir/app/shared/dialogs/new-received-piece/new-received-piece.component.ngfactory.ts